import { useState } from 'react';

const PRIVACY_TEXT = `Informativa sul trattamento dei dati personali
ai sensi dell'art. 13 del Reg. (UE) n. 2016/679

Ai sensi dell'art. 13 del Regolamento (UE) n. 2016/679 (di seguito il "GDPR"), ELLE NOLO EQUIPMENT Srl (di seguito il "Titolare") La informa che i Suoi dati personali (di seguito i "Dati"), raccolti presso di Lei o presso terzi, saranno trattati nel rispetto di quanto previsto dal GDPR e in conformità all'informativa che segue.

TITOLARE DEL TRATTAMENTO
Il Titolare del trattamento dei Dati è ELLE NOLO EQUIPMENT Srl, con sede in Firenze, Italia. Telefono: +39 055 0620108; email: ellenoloequipmentsrl@gmail.com. L'elenco aggiornato degli eventuali responsabili del trattamento è disponibile presso la sede del Titolare.

RESPONSABILE PROTEZIONE DEI DATI
Il Responsabile della protezione dei dati è contattabile tramite i recapiti sopra indicati.

FINALITÀ E BASE GIURIDICA DEL TRATTAMENTO
I Dati saranno trattati per le seguenti finalità: gestione delle richieste di preventivo e contatto, esecuzione di contratti di noleggio, adempimento di obblighi legali e contabili, invio di comunicazioni commerciali (previo consenso).

DESTINATARI O CATEGORIE DI DESTINATARI
I Dati potranno essere resi accessibili a soggetti nominati dal Titolare quali Responsabili del trattamento (es. fornitori di servizi IT, consulenti). In ogni caso, i Dati non saranno diffusi.

TRASFERIMENTO DEI DATI A PAESI TERZI
I dati circoleranno nell'ambito di paesi appartenenti all'UE. I Dati potranno essere comunicati alle società controllate dal Titolare situate in paesi non appartenenti all'Unione Europea, occasionalmente ed esclusivamente nel caso in cui il trasferimento sia necessario all'esecuzione di un contratto concluso con l'interessato (art. 49, comma 2, lett. b)).

PERIODO DI CONSERVAZIONE
I dati saranno conservati per un periodo di tempo massimo pari al periodo di prescrizione dei diritti azionabili dal Titolare, come di volta in volta applicabile.

DIRITTI DI ACCESSO, CANCELLAZIONE, LIMITAZIONE E PORTABILITÀ
Agli interessati sono riconosciuti i diritti di cui agli artt. da 15 a 20 del GDPR. A titolo esemplificativo, ciascun interessato potrà:
a) ottenere la conferma che sia o meno in corso un trattamento di dati personali che lo riguardano;
b) qualora un trattamento sia in corso, ottenere l'accesso ai dati personali e alle informazioni relative al trattamento nonché richiedere una copia dei dati personali;
c) ottenere la rettifica dei dati personali inesatti e l'integrazione dei dati personali incompleti;
d) ottenere, qualora sussista una delle condizioni previste dall'art. 17 del GDPR, la cancellazione dei dati personali che lo riguardano;
e) ottenere, nei casi previsti dall'art. 18 del GDPR, la limitazione del trattamento;
f) ricevere i dati personali che lo riguardano in un formato strutturato, di uso comune e leggibile da dispositivo automatico e richiedere la loro trasmissione ad un altro titolare, se tecnicamente fattibile.

DIRITTO DI OPPOSIZIONE
Ciascun interessato ha il diritto di opporsi in qualsiasi momento al trattamento dei suoi dati personali effettuato per il perseguimento di un legittimo interesse del Titolare. In caso di opposizione, i suoi dati personali non saranno più oggetto di trattamento, sempre che non sussistano motivi legittimi per procedere al trattamento che prevalgono sugli interessi, sui diritti e sulle libertà dell'interessato oppure per l'accertamento, l'esercizio o la difesa di un diritto in sede giudiziaria.

DIRITTO DI REVOCA DEL CONSENSO
Nel caso in cui sia richiesto il consenso per il trattamento dei dati personali, ciascun interessato potrà, altresì, revocare in qualsiasi momento il consenso già prestato, senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca.

DIRITTO DI PROPORRE RECLAMO AL GARANTE
Ciascun interessato potrà proporre reclamo al Garante per la Protezione dei Dati Personali nel caso in cui ritenga che siano stati violati i diritti di cui è titolare ai sensi del GDPR, secondo le modalità indicate sul sito internet del Garante accessibile all'indirizzo: www.garanteprivacy.it.

DIRITTI DELL'INTERESSATO
I diritti dell'interessato potranno essere esercitati tramite i recapiti di riferimento sopra indicati.`;

const PrivacyModal = ({ onClose }: { onClose: () => void }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div
      className="absolute inset-0 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    />
    <div className="relative z-10 bg-[#0f0f18] border border-gray-700/60 rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl">
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-800/60">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-950/50 border border-orange-700/50">
            <i className="ri-shield-check-line text-orange-400 text-sm" />
          </div>
          <h3 className="font-['Exo_2'] font-bold text-white text-base tracking-wide">
            Informativa Privacy — GDPR Art. 13
          </h3>
        </div>
        <button
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-700 hover:border-red-600/60 text-gray-400 hover:text-white transition-all duration-200 cursor-pointer"
        >
          <i className="ri-close-line text-sm" />
        </button>
      </div>
      {/* Body */}
      <div className="overflow-y-auto px-6 py-5 flex-1">
        <div className="font-['Inter'] text-gray-300 text-sm leading-relaxed whitespace-pre-line">
          {PRIVACY_TEXT}
        </div>
      </div>
      {/* Footer */}
      <div className="px-6 py-4 border-t border-gray-800/60 flex justify-end">
        <button
          onClick={onClose}
          className="px-6 py-2.5 bg-red-600 hover:bg-red-500 text-white font-['Exo_2'] font-bold text-xs tracking-widest uppercase rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          Ho Letto
        </button>
      </div>
    </div>
  </div>
);

const ContactSection = () => {
  const [formStatus, setFormStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [charCount, setCharCount] = useState(0);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [privacyError, setPrivacyError] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!privacyAccepted) {
      setPrivacyError(true);
      return;
    }
    const form = e.currentTarget;
    const textarea = form.querySelector('textarea');
    if (textarea && textarea.value.length > 500) {
      return;
    }
    setFormStatus('sending');
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      if (typeof value === 'string') data.append(key, value);
    });
    data.append('privacy_accettata', 'Sì');
    try {
      const res = await fetch('https://readdy.ai/api/form/d7a2fd1rcamcd36dbq5g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setFormStatus('success');
        form.reset();
        setCharCount(0);
        setPrivacyAccepted(false);
      } else {
        setFormStatus('error');
      }
    } catch {
      setFormStatus('error');
    }
  };

  return (
    <>
      {showPrivacyModal && <PrivacyModal onClose={() => setShowPrivacyModal(false)} />}

      <section id="contatti" className="relative bg-[#08080c] py-24 overflow-hidden">
        {/* Background */}
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `radial-gradient(ellipse at 20% 50%, rgba(249,115,22,0.1) 0%, transparent 60%)`,
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(rgba(220,38,38,0.03) 1px, transparent 1px),
              linear-gradient(90deg, rgba(220,38,38,0.03) 1px, transparent 1px)
            `,
            backgroundSize: '60px 60px',
          }}
        />

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Left - Info */}
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-orange-800/40 rounded-full mb-8 bg-orange-950/10">
                <span className="font-['Exo_2'] text-xs text-orange-400 tracking-[0.3em] uppercase">Contattaci</span>
              </div>

              <h2 className="font-['Exo_2'] font-black text-white text-4xl md:text-5xl tracking-tight mb-6 leading-tight">
                INIZIA IL TUO<br />
                <span className="text-orange-500">PROSSIMO</span><br />
                PROGETTO
              </h2>

              <p className="font-['Inter'] text-gray-400 text-base leading-relaxed mb-12">
                Contattaci per scoprire come possiamo supportarti nel tuo prossimo evento o competizione.
                Offriamo soluzioni rapide, efficaci e personalizzate.
              </p>

              {/* Contact Cards */}
              <div className="flex flex-col gap-4">
                <a
                  href="tel:+390550620108"
                  className="flex items-center gap-4 p-5 rounded-xl border border-red-900/30 bg-red-950/10 hover:border-red-600/50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-950/50 border border-red-700/50 group-hover:border-red-500 transition-colors">
                    <i className="ri-phone-line text-red-500 text-xl" />
                  </div>
                  <div>
                    <span className="font-['Exo_2'] font-bold text-white text-sm block">Telefono</span>
                    <span className="font-['Inter'] text-gray-400 text-sm">+39 055 0620108</span>
                  </div>
                  <div className="ml-auto w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-gray-600 group-hover:text-red-500 transition-colors" />
                  </div>
                </a>

                <a
                  href="mailto:ellenoloequipmentsrl@gmail.com"
                  className="flex items-center gap-4 p-5 rounded-xl border border-orange-900/30 bg-orange-950/10 hover:border-orange-600/50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-orange-950/50 border border-orange-700/50 group-hover:border-orange-500 transition-colors">
                    <i className="ri-mail-line text-orange-500 text-xl" />
                  </div>
                  <div>
                    <span className="font-['Exo_2'] font-bold text-white text-sm block">Email</span>
                    <span className="font-['Inter'] text-gray-400 text-sm">ellenoloequipmentsrl@gmail.com</span>
                  </div>
                  <div className="ml-auto w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-gray-600 group-hover:text-orange-500 transition-colors" />
                  </div>
                </a>

                <div className="flex items-center gap-4 p-5 rounded-xl border border-gray-800/50 bg-gray-900/10">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-900/50 border border-gray-700/50">
                    <i className="ri-map-pin-line text-gray-400 text-xl" />
                  </div>
                  <div>
                    <span className="font-['Exo_2'] font-bold text-white text-sm block">Sede</span>
                    <span className="font-['Inter'] text-gray-400 text-sm">Firenze, Italia · Attivi in tutta Europa</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right - Form */}
            <div className="bg-[#0f0f18] border border-gray-800/50 rounded-2xl p-8">
              <h3 className="font-['Exo_2'] font-bold text-white text-xl tracking-wide mb-6">
                Richiedi un Preventivo
              </h3>

              {formStatus === 'success' ? (
                <div className="flex flex-col items-center justify-center py-16 gap-4">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-green-950/50 border border-green-700/50">
                    <i className="ri-check-line text-green-500 text-3xl" />
                  </div>
                  <span className="font-['Exo_2'] font-bold text-white text-lg">Richiesta Inviata!</span>
                  <p className="font-['Inter'] text-gray-400 text-sm text-center">
                    Ti contatteremo al più presto per discutere la tua richiesta.
                  </p>
                  <button
                    onClick={() => setFormStatus('idle')}
                    className="mt-4 px-6 py-2 border border-red-700/50 rounded-full text-red-400 hover:text-white hover:border-red-500 font-['Exo_2'] text-sm tracking-widest uppercase transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Nuova Richiesta
                  </button>
                </div>
              ) : (
                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="flex flex-col gap-5"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="font-['Exo_2'] text-xs text-gray-500 tracking-widest uppercase block mb-2">
                        Nome *
                      </label>
                      <input
                        type="text"
                        name="nome"
                        required
                        placeholder="Il tuo nome"
                        className="w-full bg-[#08080c] border border-gray-800 rounded-md px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600/60 transition-colors font-['Inter']"
                      />
                    </div>
                    <div>
                      <label className="font-['Exo_2'] text-xs text-gray-500 tracking-widest uppercase block mb-2">
                        Azienda
                      </label>
                      <input
                        type="text"
                        name="azienda"
                        placeholder="Nome azienda"
                        className="w-full bg-[#08080c] border border-gray-800 rounded-md px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600/60 transition-colors font-['Inter']"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="font-['Exo_2'] text-xs text-gray-500 tracking-widest uppercase block mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="la-tua@email.com"
                      className="w-full bg-[#08080c] border border-gray-800 rounded-md px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600/60 transition-colors font-['Inter']"
                    />
                  </div>

                  <div>
                    <label className="font-['Exo_2'] text-xs text-gray-500 tracking-widest uppercase block mb-2">
                      Telefono
                    </label>
                    <input
                      type="tel"
                      name="telefono"
                      placeholder="+39 000 0000000"
                      className="w-full bg-[#08080c] border border-gray-800 rounded-md px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600/60 transition-colors font-['Inter']"
                    />
                  </div>

                  <div>
                    <label className="font-['Exo_2'] text-xs text-gray-500 tracking-widest uppercase block mb-2">
                      Servizio di Interesse
                    </label>
                    <select
                      name="servizio"
                      className="w-full bg-[#08080c] border border-gray-800 rounded-md px-4 py-3 text-sm text-gray-300 focus:outline-none focus:border-red-600/60 transition-colors font-['Inter'] cursor-pointer"
                    >
                      <option value="">Seleziona un servizio</option>
                      <option value="motorsport">Motorsport</option>
                      <option value="eventi">Eventi Fieristici</option>
                      <option value="catering">Catering &amp; Hospitality</option>
                      <option value="ricambi">Ricambistica Auto</option>
                      <option value="energia">Energia &amp; Generatori</option>
                      <option value="camper">Camper &amp; Veicoli</option>
                    </select>
                  </div>

                  <div>
                    <label className="font-['Exo_2'] text-xs text-gray-500 tracking-widest uppercase block mb-2">
                      Messaggio *
                    </label>
                    <textarea
                      name="messaggio"
                      required
                      rows={4}
                      maxLength={500}
                      placeholder="Descrivi la tua richiesta..."
                      onChange={(e) => setCharCount(e.target.value.length)}
                      className="w-full bg-[#08080c] border border-gray-800 rounded-md px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600/60 transition-colors font-['Inter'] resize-none"
                    />
                    <div className="flex justify-end mt-1">
                      <span className={`font-['Inter'] text-xs ${charCount > 480 ? 'text-red-400' : 'text-gray-600'}`}>
                        {charCount}/500
                      </span>
                    </div>
                  </div>

                  {/* Privacy Checkbox */}
                  <div className={`rounded-lg border p-4 transition-colors duration-200 ${privacyError && !privacyAccepted ? 'border-red-500/60 bg-red-950/10' : 'border-gray-800/60 bg-[#08080c]'}`}>
                    <label className="flex items-start gap-3 cursor-pointer group">
                      <div className="relative mt-0.5 flex-shrink-0">
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={privacyAccepted}
                          onChange={(e) => {
                            setPrivacyAccepted(e.target.checked);
                            if (e.target.checked) setPrivacyError(false);
                          }}
                        />
                        <div
                          className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200 ${
                            privacyAccepted
                              ? 'bg-red-600 border-red-600'
                              : privacyError
                              ? 'border-red-500 bg-transparent'
                              : 'border-gray-600 bg-transparent group-hover:border-red-600/60'
                          }`}
                        >
                          {privacyAccepted && (
                            <i className="ri-check-line text-white text-xs" />
                          )}
                        </div>
                      </div>
                      <span className="font-['Inter'] text-xs text-gray-400 leading-relaxed">
                        Ho letto e accetto l&apos;
                        <button
                          type="button"
                          onClick={() => setShowPrivacyModal(true)}
                          className="text-orange-400 hover:text-orange-300 underline underline-offset-2 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                        >
                          Informativa sul trattamento dei dati personali
                        </button>
                        {' '}ai sensi dell&apos;art. 13 del Reg. (UE) n. 2016/679 (GDPR).{' '}
                        <span className="text-red-400 font-semibold">*</span>
                      </span>
                    </label>
                    {privacyError && !privacyAccepted && (
                      <p className="font-['Inter'] text-red-400 text-xs mt-2 ml-8">
                        Devi accettare l&apos;informativa privacy per procedere.
                      </p>
                    )}
                  </div>

                  {formStatus === 'error' && (
                    <p className="font-['Inter'] text-red-400 text-sm text-center">
                      Errore nell&apos;invio. Riprova o contattaci direttamente.
                    </p>
                  )}

                  <button
                    type="submit"
                    disabled={formStatus === 'sending' || charCount > 500}
                    className="w-full py-4 bg-red-600 hover:bg-red-500 disabled:bg-gray-700 disabled:cursor-not-allowed text-white font-['Exo_2'] font-bold text-sm tracking-widest uppercase rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    {formStatus === 'sending' ? 'Invio in corso...' : 'Invia Richiesta'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;
